import React from 'react'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import {
  Box,
  Paper,
  Grid,
  Typography,
  TextField,
  MenuItem,
  Button,
  Tabs,
  Tab,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Dialog,
  DialogContent,
  Divider,
  withStyles,
  IconButton,
  Chip,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import Pagination from '@material-ui/lab/Pagination'
import HeaderTitle from '../../components/Header/HeaderTitle'
import apiConfig from '../../config/apiConfig'
import axios from 'axios'
import { showNotification } from './../../app/Notifications/NotificationActionCreator'
import {
  SUCCESS_MSG_SHOW_NOTIFICATION_SUPPORT_FORM,
  ERROR_MSG_SHOW_NOTIFICATION_SUPPORT_FORM,
  ERROR_MSG_FOR_WRONG_FILE_UPLOAD_SUPPORT_FORM,
  ERROR_MSG_FOR_DESCRIPTION_SUPPORT_FORM,
} from './displayMessages'
import AttachFileIcon from '@mui/icons-material/AttachFile'
import { isTPlus } from '../../app/Auth/Auth'
import FormHelperText from '@mui/material/FormHelperText'
import CommentsSection from './CommentsSection'

function formatLocaleDateTime(dateStr) {
  try {
    if (dateStr && !/Z$/.test(dateStr)) {
      dateStr += 'Z'
    }
    const date = new Date(dateStr)
    return date.toLocaleString(navigator.language || 'en-US', {
      dateStyle: 'short',
      timeStyle: 'short',
    })
  } catch (e) {
    return dateStr
  }
}

const fileType = [
  // 'video/mp4',
  'image/png',
  'image/jpeg',
  'image/jpg',
  'application/pdf',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
]

const issueType = [
  { value: '', label: 'Select Ticket Type' },
  { value: 'Defect', label: 'Defect' },
  { value: 'New Feature', label: 'New Feature' },
  { value: 'Feedback', label: 'Feedback' },
]
const priority = [
  { value: '', label: 'Select Priority (Optional)' },
  { value: 'Low', label: 'Low' },
  { value: 'Medium', label: 'Medium' },
  { value: 'High', label: 'High' },
]
const phases = [
  { value: 'Agency_HighPoly', label: 'Agency HighPoly' },
  { value: 'Agency_Scene_building', label: 'Agency Scene building' },
  { value: 'Vendor_Input_flow', label: 'Vendor Input flow' },
]

const TPlusPhases = [{ value: 'Target_Plus', label: 'Target Plus' }]
// eslint-disable-next-line no-unused-vars
const systemModulePhases = [
  {
    label: 'Projects',
    value: 'Projects',
  },
  {
    label: 'Search & Filter',
    value: 'Search & Filter',
  },
  { label: 'Rework', value: 'Rework' },
  { label: 'Reports', value: 'Reports' },
]

function getChipStyle(status) {
  switch (status) {
    case 'To Do':
      return { backgroundColor: '#757575', color: '#fff' }
    case 'In Progress':
      return { backgroundColor: '#1976d2', color: '#fff' }
    case 'Testing':
      return { backgroundColor: '#9c27b0', color: '#fff' }
    case 'Done':
      return { backgroundColor: '#388e3c', color: '#fff' }
    default:
      return {}
  }
}

function TabPanel(props) {
  const { children, value, index, className, ...other } = props
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`support-tabpanel-${index}`}
      aria-labelledby={`support-tab-${index}`}
      className={className}
      {...other}
    >
      {value === index && children}
    </div>
  )
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  className: PropTypes.string,
}

const attractiveStyles = (theme) => ({
  dialogPaper: {
    borderRadius: 8,
    overflow: 'hidden',
  },
  header: {
    background: '#ac0000',
    padding: theme.spacing(1),
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    fontSize: '1rem',
    fontWeight: 700,
    marginLeft: 16,
    maxWidth: 'calc(100% - 80px)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  closeButton: {
    color: '#fff',
  },
  content: {
    padding: theme.spacing(3),
    backgroundColor: '#f7f7f7',
    paddingTop: '8px',
  },
  section: {
    marginBottom: theme.spacing(3),
  },
  sectionTitle: {
    fontWeight: 500,
    marginBottom: theme.spacing(1),
    color: '#333',
    fontSize: '1rem',
    marginTop: theme.spacing(1),
  },
  infoGrid: {
    backgroundColor: '#fff',
    padding: theme.spacing(2),
  },
  avatar: {
    backgroundColor: theme.palette.secondary.main,
    marginRight: theme.spacing(1),
  },
  commentCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: '#fff',
  },
  attachmentImage: {
    width: '100%',
    borderRadius: 8,
  },
})

const IssueDetailModal = ({
  open,
  onClose,
  issue,
  classes,
  attachmentPreviews,
  fetchAttachmentBlob,
  onAddComment,
}) => {
  const renderAttachmentPreview = (ticketId, attachment, index) => {
    console.log(attachmentPreviews)
    const preview = attachmentPreviews[attachment.attachment_id]
    if (!preview) {
      fetchAttachmentBlob(ticketId, attachment)
      return (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Paper elevation={3} style={{ padding: 8, textAlign: 'center' }}>
            <Typography variant="body2">Loading...</Typography>
          </Paper>
        </Grid>
      )
    }

    const { url, type, filename } = preview
    const isImage = type?.startsWith('image/')
    const isPdf = type === 'application/pdf'

    return (
      <Grid item xs={12} sm={6} md={4} key={index}>
        <Paper elevation={3} style={{ padding: 8, textAlign: 'center' }}>
          {isImage ? (
            <img src={url} alt={filename} className={classes.attachmentImage} />
          ) : isPdf ? (
            <embed
              src={url}
              type="application/pdf"
              className={classes.attachmentImage}
            />
          ) : (
            <Typography variant="body2">Preview not supported</Typography>
          )}
          <Box mt={1}>
            <a
              href={url}
              download={filename}
              style={{ textDecoration: 'none' }}
            >
              <Typography variant="caption" style={{ color: '#1976d2' }}>
                {filename}
              </Typography>
            </a>
          </Box>
        </Paper>
      </Grid>
    )
  }

  if (!issue) return null

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      classes={{ paper: classes.dialogPaper }}
    >
      <div className={classes.header}>
        <Typography className={classes.title}>
          {issue.ticket_key} - {issue.summary}
        </Typography>
        <IconButton onClick={onClose} className={classes.closeButton}>
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent className={classes.content}>
        <div className={classes.section}>
          <Typography variant="h6" className={classes.sectionTitle}>
            Ticket Details
          </Typography>
          <Paper className={classes.infoGrid} elevation={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ lineHeight: '2' }}>
                  <strong>ID:</strong> {issue.ticket_key}
                </Typography>
                <Typography variant="body1" style={{ lineHeight: '2' }}>
                  <strong>Type:</strong> {issue.ticket_type}
                </Typography>
                <Typography variant="body1" style={{ lineHeight: '2' }}>
                  <strong>Priority:</strong> {issue.priority}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" style={{ lineHeight: '2' }}>
                  <strong>Status:</strong>{' '}
                  <Chip
                    label={issue.status}
                    style={getChipStyle(issue.status)}
                  />
                </Typography>
                <Typography variant="body1" style={{ lineHeight: '2' }}>
                  <strong>Created:</strong>{' '}
                  {formatLocaleDateTime(issue.created_date)}
                </Typography>
                <Typography variant="body1" style={{ lineHeight: '2' }}>
                  <strong>Updated:</strong>{' '}
                  {formatLocaleDateTime(issue.updated_date)}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        </div>
        <Divider />
        <div className={classes.section}>
          <Typography variant="h6" className={classes.sectionTitle}>
            Description
          </Typography>
          <Typography variant="body1" style={{ whiteSpace: 'pre-wrap' }}>
            {issue.description.split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </Typography>
        </div>
        <Divider />
        {issue.attachments && issue.attachments.length > 0 && (
          <>
            <Divider />
            <div className={classes.section}>
              <Typography variant="h6" className={classes.sectionTitle}>
                Attachments
              </Typography>
              <Grid container spacing={2}>
                {issue.attachments.map((att, index) =>
                  renderAttachmentPreview(issue.ticket_key, att, index)
                )}
              </Grid>
            </div>
          </>
        )}
        {issue.comment_section && issue.comment_section.comments && (
          <>
            <Divider />
            <div className={classes.section}>
              <CommentsSection
                comments={issue.comment_section.comments}
                totalComments={issue.comment_section.total}
                ticketKey={issue.ticket_key}
                onAddComment={onAddComment}
              />
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  )
}

IssueDetailModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  issue: PropTypes.shape({
    ticket_id: PropTypes.string,
    ticket_key: PropTypes.string,
    ticket_type: PropTypes.string,
    project: PropTypes.string,
    summary: PropTypes.string,
    description: PropTypes.string,
    priority: PropTypes.string,
    created_date: PropTypes.string,
    updated_date: PropTypes.string,
    reporter: PropTypes.shape({
      displayName: PropTypes.string,
      emailAddress: PropTypes.string,
    }),
    assignee: PropTypes.shape({
      displayName: PropTypes.string,
      emailAddress: PropTypes.string,
    }),
    status: PropTypes.string,
    attachments: PropTypes.arrayOf(
      PropTypes.shape({
        filename: PropTypes.string,
        thumbnail: PropTypes.string,
        type: PropTypes.string,
      })
    ),
    comment_section: PropTypes.shape({
      total: PropTypes.number,
      comments: PropTypes.arrayOf(
        PropTypes.shape({
          author: PropTypes.shape({
            displayName: PropTypes.string,
          }),
          body: PropTypes.string,
          created_date: PropTypes.string,
        })
      ),
    }),
  }),
  classes: PropTypes.object.isRequired,
  attachmentPreviews: PropTypes.object.isRequired,
  fetchAttachmentBlob: PropTypes.func.isRequired,
  onAddComment: PropTypes.func.isRequired,
}

const AttractiveModal = withStyles(attractiveStyles)(IssueDetailModal)

const styles2 = (theme) => ({
  root: {
    backgroundColor: '#FAFAFA',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  centerWrapper: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  mainPaper: {
    width: '100%',
    borderRadius: 4,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginTop: '85px',
  },
  tabsRoot: { backgroundColor: '#FFFFFF' },
  indicator: { backgroundColor: '#D32F2F', height: 3 },
  tabRoot: {
    fontWeight: 400,
    fontSize: '0.95rem',
    minHeight: 60,
    color: 'grey',
    borderBottom: '1px solid #ddd',
    '&:hover': { backgroundColor: '#f7f7f7' },
  },
  tabSelected: { color: '#ac0000' },
  tabPanel: {
    padding: theme.spacing(2),
    overflow: 'auto',
    maxWidth: '1000px',
    margin: '0 auto',
    height: '83vh',
    scrollbarWidth: 'none',
    '-ms-overflow-style': 'none',
    '&::-webkit-scrollbar': { display: 'none' },
  },
  formHeading: {
    fontWeight: 400,
    marginBottom: theme.spacing(3),
    color: '#333',
  },
  inputFile: { display: 'none' },
  previewImage: {
    width: '100%',
    maxWidth: 150,
    height: 100,
    objectFit: 'cover',
    borderRadius: 4,
    boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
  },
  previewEqual: {
    width: 150,
    height: 150,
    objectFit: 'cover',
    borderRadius: 4,
    boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
  },
  attachmentPaper: { padding: theme.spacing(2), textAlign: 'center' },
  statusPaper: { marginTop: theme.spacing(2), padding: theme.spacing(2) },
  fileNamePreviewText: {
    overflow: 'hidden',
    width: '100%',
    textAlign: 'center',
    textDecoration: 'none',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  submitButton: {
    backgroundColor: '#ac0000',
    color: '#fff',
    padding: theme.spacing(1, 4),
    fontSize: '0.95rem',
    fontWeight: 400,
    textTransform: 'none',
    '&:hover': { backgroundColor: '#C62828' },
  },
})

class SupportForm extends React.Component {
  snapShotFileID = React.createRef()
  state = {
    title: '',
    issueTypeChoosed: '',
    priorityChoosed: '',
    phase: '',
    file: [],
    description: '',
    preview: [],
    externalEmail: '',
    isLoading: false,
    errorTitle: false,
    errorDescription: false,
    errorIssueType: false,
    errorFileStatus: false,
    errorFileMaxLength: false,
    errorExternalEmail: false,
    tabValue: 0,
    issues: [],
    currentPage: 1,
    totalPages: 0,
    selectedIssue: null,
    modalOpen: false,
    attachmentPreviews: {},
  }

  renderPhaseOptions = () => {
    const phasesOptions = !isTPlus ? [...phases] : [...TPlusPhases]
    const mergedOptions = [
      // { disabled: true, label: 'System Module' },
      // ...systemModulePhases,
      { disabled: true, label: 'Workflow Phase' },
      ...phasesOptions,
    ]
    return mergedOptions.map((option, index) => {
      if (option.disabled) {
        return (
          <MenuItem
            key={`phase-${index}`}
            disabled
            style={{ color: '#978787' }}
          >
            {option.label}
          </MenuItem>
        )
      }
      return (
        <MenuItem key={`phase-${index}`} value={option.value}>
          {option.label}
        </MenuItem>
      )
    })
  }

  componentDidMount() {
    this.setState({ isLoading: false })
  }

  handleTabChange = (event, newValue) => {
    if (newValue === 1) {
      this.fetchIssues(this.state.currentPage)
    }
    this.setState({ tabValue: newValue })
  }
  handleChangeTitle = (event) => {
    const title = event.target.value
    const trimmedTitle = title.trim()
    const errorTitle = trimmedTitle === '' || trimmedTitle.length > 255
    this.setState({ title, errorTitle })
  }

  handleChangeDescription = (event) => {
    const description = event.target.value
    const trimmedDescription = description.trim()
    const errorDescription =
      trimmedDescription === '' || trimmedDescription.length > 32767
    this.setState({ description, errorDescription })
  }
  handleChangeIssueTypeChoosed = (event) => {
    this.setState({
      issueTypeChoosed: event.target.value,
      errorIssueType: false,
    })
  }
  handleChangePriorityChoosed = (event) => {
    this.setState({ priorityChoosed: event.target.value })
  }
  handleChangePhase = (event) => {
    this.setState({ phase: event.target.value })
  }
  handleChangeExternalEmail = (event) => {
    this.setState({
      externalEmail: event.target.value,
      errorExternalEmail: false,
    })
  }

  readURL = async (event) => {
    const newFiles = Array.from(event.target.files)
    if (!newFiles.length) return

    const currentFiles = this.state.file
    const currentPreviews = this.state.preview

    if (currentFiles.length + newFiles.length > 5) {
      this.setState({ errorFileMaxLength: true })
      if (this.snapShotFileID.current) this.snapShotFileID.current.value = ''
      return
    }
    const MAX_FILE_SIZE = 1 * 1024 * 1024
    for (let file of newFiles) {
      if (file.size > MAX_FILE_SIZE) {
        this.setState({
          errorFileStatus: 'Uploaded file size is more than 1 MB',
        })
        if (this.snapShotFileID.current) this.snapShotFileID.current.value = ''
        return
      }
    }

    for (let file of newFiles) {
      if (!fileType.includes(file.type)) {
        this.setState({ errorFileStatus: 'File type not allowed' })
        if (this.snapShotFileID.current) this.snapShotFileID.current.value = ''
        return
      }
    }
    this.setState({ errorFileStatus: false, errorFileMaxLength: false })

    try {
      const newPreviews = await Promise.all(
        newFiles.map((file) => {
          return new Promise((resolve, reject) => {
            const reader = new window.FileReader()
            reader.onload = (e) => resolve(e.target.result)
            reader.onerror = (error) => reject(error)
            reader.readAsDataURL(file)
          })
        })
      )
      this.setState({
        file: [...currentFiles, ...newFiles],
        preview: [...currentPreviews, ...newPreviews],
      })
    } catch (error) {
      console.error('Error reading files', error)
    }
  }

  removeSingleSnapshot = (index) => {
    const { file, preview } = this.state
    const newFiles = [...file]
    const newPreviews = [...preview]
    newFiles.splice(index, 1)
    newPreviews.splice(index, 1)
    this.setState({ file: newFiles, preview: newPreviews })
    if (newFiles.length === 0 && this.snapShotFileID.current) {
      this.snapShotFileID.current.value = ''
    }
  }
  removeAllSnapshots = () => {
    this.setState({ file: [], preview: [] })
    if (this.snapShotFileID.current) {
      this.snapShotFileID.current.value = ''
    }
  }
  resetForm = () => {
    this.setState({
      title: '',
      issueTypeChoosed: '',
      priorityChoosed: '',
      phase: '',
      file: [],
      description: '',
      preview: [],
      externalEmail: '',
      errorTitle: false,
      errorDescription: false,
      errorIssueType: false,
      errorFileStatus: false,
      errorFileMaxLength: false,
      errorExternalEmail: false,
      isLoading: false,
      isTableStatusLoading: false,
    })
    if (this.snapShotFileID.current) {
      this.snapShotFileID.current.value = ''
    }
  }
  supportFormSubmit = async () => {
    const { title, priorityChoosed, phase, description, file, externalEmail } =
      this.state
    const { email, showNotification, isExternal } = this.props

    let hasError = false
    const newErrors = {}

    const trimmedTitle = title.trim()
    const titleRegex = /^[a-zA-Z0-9 \\/.,\\-]+$/
    if (
      trimmedTitle === '' ||
      trimmedTitle.length > 255 ||
      !titleRegex.test(trimmedTitle)
    ) {
      newErrors.errorTitle = true
      hasError = true
    } else {
      newErrors.errorTitle = false
    }

    const trimmedDescription = description.trim()
    if (trimmedDescription === '' || trimmedDescription.length > 32767) {
      newErrors.errorDescription = true
      hasError = true
    } else {
      newErrors.errorDescription = false
    }

    if (isExternal) {
      if (externalEmail.trim() === '' || !isValidEmail(externalEmail.trim())) {
        newErrors.errorExternalEmail = true
        hasError = true
      } else {
        newErrors.errorExternalEmail = false
      }
    }

    this.setState(newErrors)
    if (hasError) return

    const issue = 'Defect'
    const prior = priorityChoosed
    const SUBMIT_SUPPORT_FORM_URL = apiConfig.support.submitForm
    const UPLOAD_SNAPSHOT = apiConfig.support.uploadSnapShot
    const src = 'EXTERNAL GARGANTUA'
    const reqData = {
      email: isExternal ? externalEmail.trim() : email,
      title: trimmedTitle,
      ticket_type: issue,
      src,
      description: trimmedDescription,
      priority: prior,
    }
    if (phase && phase.trim() !== '') {
      reqData.phase = phase
    }
    this.setState({ isTableStatusLoading: true })
    const headers = { 'Content-Type': 'application/json' }
    try {
      const response = await axios.post(SUBMIT_SUPPORT_FORM_URL, reqData, {
        headers,
      })
      const { data: fbuRespData = {} } = response
      const { ticket_key = '' } = fbuRespData
      if (!ticket_key) {
        throw new Error('Invalid ticket Key received')
      }

      const extractNumber = (str) => {
        const match = str.match(/\d+/)
        return match ? match[0] : ''
      }
      if (file && file.length > 0) {
        const url = `${UPLOAD_SNAPSHOT}${extractNumber(ticket_key)}/attachments`
        let formData = new FormData()
        file.forEach((singleFile) => {
          formData.append('files', singleFile)
        })
        await axios.put(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
      }
      showNotification(
        true,
        SUCCESS_MSG_SHOW_NOTIFICATION_SUPPORT_FORM,
        'success'
      )
      this.resetForm()
    } catch (error) {
      if (error.response && error.response.status === 415) {
        showNotification(
          true,
          'Attachment payload too large. Please upload smaller file(s).',
          'error'
        )
      }
      showNotification(true, ERROR_MSG_SHOW_NOTIFICATION_SUPPORT_FORM, 'error')
      this.resetForm()
    }
  }

  fetchIssues = async (pageNumber = 1) => {
    const { showNotification } = this.props
    this.setState({ isLoading: true })
    const VIEW_ISSUES_URL = apiConfig.support.viewIssues
    const size = 8
    const start = (pageNumber - 1) * size
    const headers = { 'Content-Type': 'application/json' }
    try {
      const response = await axios.get(
        `${VIEW_ISSUES_URL}?start=${start}&size=${size}`,
        { headers }
      )
      const { total, data } = response.data
      const totalPages = Math.ceil(total / size)
      this.setState({
        issues: data || [],
        currentPage: pageNumber,
        totalPages: totalPages || 0,
        isLoading: false,
      })
    } catch (error) {
      console.error('Fetch issues error:', error)
      this.setState({ isLoading: false })
      showNotification(
        true,
        'Sorry! We could not fetch the issues. Please contact support.',
        'error'
      )
    }
  }

  fetchSingleIssue = async (ticketId) => {
    try {
      const trimmedId = ticketId.toString().trim()
      // Update this URL to match your API endpoint
      const url = `${apiConfig.support.viewIssues}?id=${trimmedId}&src=EXT_GGA`
      const response = await axios.get(url, {
        headers: { 'Content-Type': 'application/json' },
      })
      const issue = response.data?.data?.[0]
      return issue
    } catch (error) {
      console.error('Error fetching issue:', error)
      return null
    }
  }

  addComment = async (ticket_id, commentText) => {
    try {
      const extractNumber = (str) => {
        const match = str.trim().match(/\d+/)
        return match ? match[0] : ''
      }
      const numericId = extractNumber(ticket_id)
      // Update this URL to match your API endpoint
      const url = `${apiConfig.support.addComment}${numericId}/comments`
      const reqData = {
        comment: commentText,
      }
      const response = await axios.post(url, reqData, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      // Refreshing the ticket for the latest comments
      const refreshed = await this.fetchSingleIssue(numericId)
      if (refreshed) {
        this.setState({ selectedIssue: refreshed })
      }
      this.props.showNotification(
        true,
        'Comment added successfully!',
        'success'
      )
      return response.data
    } catch (error) {
      this.props.showNotification(
        true,
        'Failed to add comment. Please try again.',
        'error'
      )
      throw error
    }
  }

  handleIssueClick = (issue) => {
    this.setState({ selectedIssue: issue, modalOpen: true })
  }

  renderAttachments = () => {
    const { preview, file } = this.state
    const { classes } = this.props
    if (!preview.length) return null
    return (
      <Grid item xs={12}>
        <Typography variant="subtitle1" gutterBottom>
          Attachments:
        </Typography>
        <Grid container spacing={2}>
          {preview.map((imgSrc, index) => {
            const currentFile = file[index]
            return (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Paper variant="outlined" className={classes.attachmentPaper}>
                  {(() => {
                    if (currentFile.type.startsWith('image/')) {
                      return (
                        <img
                          src={imgSrc}
                          alt={`Preview ${index}`}
                          className={classes.previewEqual}
                        />
                      )
                    } else if (currentFile.type === 'application/pdf') {
                      return (
                        <embed
                          src={imgSrc}
                          type="application/pdf"
                          className={classes.previewEqual}
                        />
                      )
                    } else if (currentFile.type.startsWith('video/')) {
                      return (
                        <video controls className={classes.previewEqual}>
                          <source src={imgSrc} type={currentFile.type} />
                          Your browser does not support the video tag.
                        </video>
                      )
                    } else {
                      return <Typography variant="body2">No Preview</Typography>
                    }
                  })()}
                  <Box mt={1}>
                    <Typography
                      variant="body2"
                      className={classes.fileNamePreviewText}
                    >
                      {currentFile.name}
                    </Typography>
                  </Box>
                  <Box mt={1} textAlign="center">
                    <Button
                      onClick={() => this.removeSingleSnapshot(index)}
                      color="secondary"
                      size="small"
                    >
                      Remove
                    </Button>
                  </Box>
                </Paper>
              </Grid>
            )
          })}
        </Grid>
        <Box textAlign="center" mt={2}>
          <Button onClick={this.removeAllSnapshots} color="secondary">
            Remove All
          </Button>
        </Box>
      </Grid>
    )
  }

  renderStatusTab = () => {
    const { classes } = this.props
    const { issues, isLoading, currentPage, totalPages } = this.state
    return (
      <>
        <Paper elevation={1} className={classes.statusPaper}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Ticket ID</TableCell>
                  <TableCell>Summary</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Created Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      Loading...
                    </TableCell>
                  </TableRow>
                ) : issues.length > 0 ? (
                  issues.map((issue) => (
                    <TableRow
                      key={issue.ticket_key}
                      hover
                      onClick={() => this.handleIssueClick(issue)}
                      style={{ cursor: 'pointer' }}
                    >
                      <TableCell>{issue.ticket_key}</TableCell>
                      <TableCell
                        style={{
                          maxWidth: 200,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {issue.summary}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={issue.status}
                          style={getChipStyle(issue.status)}
                        />
                      </TableCell>
                      <TableCell>
                        {formatLocaleDateTime(issue.created_date)}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No issues submitted yet.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {totalPages > 1 && (
            <Box mt={2} display="flex" justifyContent="center">
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={(event, value) => this.fetchIssues(value)}
                color="secondary"
              />
            </Box>
          )}
        </Paper>
      </>
    )
  }

  fetchAttachmentBlob = async (ticket_id, attachment) => {
    const { attachment_id, filename } = attachment
    const extractNumber = (str) => {
      const match = str.match(/\d+/)
      console.log(match)
      return match ? match[0] : ''
    }
    try {
      const response = await axios.get(
        `${apiConfig.support.getAttachments}/${extractNumber(
          ticket_id
        )}/attachments/${attachment_id}`,
        { responseType: 'blob' }
      )
      const mimeType = response.headers['content-type']
      const blob = new Blob([response.data], { type: mimeType })
      const url = URL.createObjectURL(blob)
      this.setState((prevState) => ({
        attachmentPreviews: {
          ...prevState.attachmentPreviews,
          [attachment_id]: { url, type: mimeType, filename },
        },
      }))
    } catch (error) {
      console.error('Failed to fetch attachment:', error)
    }
  }

  render() {
    const { classes, isExternal } = this.props
    const {
      title,
      issueTypeChoosed,
      priorityChoosed,
      phase,
      description,
      errorFileStatus,
      externalEmail,
      tabValue,
      errorTitle,
      errorDescription,
      errorIssueType,
      errorFileMaxLength,
      errorExternalEmail,
      modalOpen,
      selectedIssue,
      isTableStatusLoading,
    } = this.state
    return (
      <div className={classes.root}>
        <Helmet>
          <title>Support - Raise a Ticket</title>
        </Helmet>
        <HeaderTitle title="Support" />
        <Box className={classes.centerWrapper}>
          <Paper className={classes.mainPaper}>
            <Tabs
              value={tabValue}
              onChange={this.handleTabChange}
              variant="fullWidth"
              classes={{ indicator: classes.indicator }}
              className={classes.tabsRoot}
            >
              <Tab
                label="RAISE A TICKET"
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected,
                }}
              />
              <Tab
                label="VIEW STATUS"
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected,
                }}
              />
            </Tabs>
            <TabPanel value={tabValue} index={0} className={classes.tabPanel}>
              <Typography variant="h6" className={classes.formHeading}>
                Raise a Ticket
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} style={{ paddingBottom: 0 }}>
                  <TextField
                    label="Ticket Title"
                    variant="outlined"
                    fullWidth
                    value={title}
                    onChange={this.handleChangeTitle}
                    error={errorTitle}
                    inputProps={{
                      maxLength: 256,
                    }}
                  />
                  <FormHelperText
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      color: errorTitle ? '#f44336' : 'rgba(0, 0, 0, 0.6)',
                      marginTop: 4,
                    }}
                  >
                    <span>
                      {errorTitle && title.trim() === ''
                        ? 'Ticket Title is required'
                        : title.length > 255
                        ? 'Title should not exceed 255 characters'
                        : ''}
                    </span>
                    <span>{`${title.length}/255`}</span>
                  </FormHelperText>
                </Grid>
                {false && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      select
                      label="Ticket Type"
                      variant="outlined"
                      fullWidth
                      value={issueTypeChoosed}
                      onChange={this.handleChangeIssueTypeChoosed}
                      error={errorIssueType}
                      helperText={
                        errorIssueType ? 'Ticket Type is required' : ''
                      }
                    >
                      {issueType.map((option, index) => (
                        <MenuItem
                          key={`${option.value}-${index}`}
                          value={option.value}
                        >
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                )}
                <Grid item xs={12} sm={12}>
                  <TextField
                    select
                    label="Priority (Optional)"
                    variant="outlined"
                    fullWidth
                    value={priorityChoosed}
                    onChange={this.handleChangePriorityChoosed}
                  >
                    {priority.map((option, index) => (
                      <MenuItem
                        key={`${option.value}-${index}`}
                        value={option.value}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                {!isTPlus && (
                  <Grid item xs={12}>
                    <TextField
                      select
                      label="Select Phase (Optional)"
                      variant="outlined"
                      fullWidth
                      value={phase}
                      onChange={this.handleChangePhase}
                    >
                      {this.renderPhaseOptions()}
                    </TextField>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <TextField
                    label="Describe the Ticket"
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={6}
                    value={description}
                    onChange={this.handleChangeDescription}
                    error={errorDescription}
                    helperText={
                      errorDescription
                        ? description.trim() === ''
                          ? ERROR_MSG_FOR_DESCRIPTION_SUPPORT_FORM
                          : 'Description should not exceed 32767 characters'
                        : ''
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box display="flex" alignItems="center">
                    <input
                      accept={fileType.join()}
                      className={classes.inputFile}
                      id="file-input"
                      type="file"
                      onChange={this.readURL}
                      ref={this.snapShotFileID}
                      multiple
                    />
                    <label htmlFor="file-input">
                      <Button
                        variant="outlined"
                        color="secondary"
                        component="span"
                        style={{
                          color: '#ac0000',
                          borderColor: '#ac0000',
                          width: '100%',
                        }}
                      >
                        <AttachFileIcon />
                        Attachments
                      </Button>
                    </label>
                    <FormHelperText style={{ marginLeft: '10px' }}>
                      Upload up to 5 files (Max: 1MB per file).
                    </FormHelperText>
                    {errorFileStatus && (
                      <Typography
                        variant="caption"
                        color="error"
                        style={{ marginLeft: 16 }}
                      >
                        {typeof errorFileStatus === 'string'
                          ? errorFileStatus
                          : ERROR_MSG_FOR_WRONG_FILE_UPLOAD_SUPPORT_FORM}
                      </Typography>
                    )}
                    {errorFileMaxLength && (
                      <Typography
                        variant="caption"
                        color="error"
                        style={{ marginLeft: 16 }}
                      >
                        Please upload maximum 5 files.
                      </Typography>
                    )}
                  </Box>
                </Grid>
                {this.renderAttachments()}
                {isExternal && (
                  <Grid item xs={12}>
                    <TextField
                      label="Email (for clarifications)"
                      variant="outlined"
                      fullWidth
                      value={externalEmail}
                      onChange={this.handleChangeExternalEmail}
                      error={errorExternalEmail}
                      helperText={
                        errorExternalEmail
                          ? 'Email is required for clarifications'
                          : 'We will use this email for any clarifications or updates.'
                      }
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Box textAlign="center" mt={2}>
                    <Button
                      variant="contained"
                      onClick={this.supportFormSubmit}
                      disabled={isTableStatusLoading}
                      className={classes.submitButton}
                      fullWidth
                    >
                      {isTableStatusLoading ? (
                        <span>
                          Submitting...{' '}
                          <i className="fas fa-circle-notch fa-spin" />
                        </span>
                      ) : (
                        'Submit'
                      )}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </TabPanel>
            <TabPanel value={tabValue} index={1} className={classes.tabPanel}>
              {this.renderStatusTab()}
            </TabPanel>
          </Paper>
        </Box>
        {modalOpen && (
          <AttractiveModal
            open={modalOpen}
            onClose={() => this.setState({ modalOpen: false })}
            issue={selectedIssue}
            attachmentPreviews={this.state.attachmentPreviews}
            fetchAttachmentBlob={this.fetchAttachmentBlob}
            onAddComment={this.addComment}
          />
        )}
      </div>
    )
  }
}

SupportForm.propTypes = {
  classes: PropTypes.object.isRequired,
  showNotification: PropTypes.func,
  email: PropTypes.string,
  isExternal: PropTypes.bool,
}

SupportForm.defaultProps = {
  isExternal: false,
}

const mapStateToProps = (state) => {
  const {
    auth: { email },
  } = state
  const {
    nbrVendorConfirm: { vendor_id },
  } = state.nationalBrand
  return { email, vendor_id }
}

export default connect(mapStateToProps, { showNotification })(
  withStyles(styles2)(SupportForm)
)

function isValidEmail(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return re.test(String(email).toLowerCase())
}
